import api from "../../../axiosConfig";

export const emailContactsApi = {
  list: async ({
    q = "",
    source = "",
    active = "1",
    perPage = 100,
    page = 1,
    segment = "",
    excludeRecent = null,
    days = null,
    audienceKind = null,
  } = {}) => {
    const params = new URLSearchParams();
    params.set("per_page", String(perPage));
    params.set("page", String(page));
    if (q) params.set("q", q);
    if (source) params.set("source", source);
    if (segment) params.set("segment", segment);
    if (active !== "" && active !== null && active !== undefined) params.set("active", String(active));
    if (excludeRecent !== null && excludeRecent !== undefined) params.set("exclude_recent", String(excludeRecent));
    if (days !== null && days !== undefined && String(days) !== "") params.set("days", String(days));
    if (audienceKind) params.set("audience_kind", audienceKind);
    const res = await api.get(`/email/contacts?${params.toString()}`);
    return res.data;
  },

  estimate: async ({
    q = "",
    source = null,
    active = true,
    limit = 2000,
    preferredLimit = null,
    excludeRecent = true,
    days = 7,
    segment = "",
    audienceKind = null,
    includeMyContacts = null,
  } = {}) => {
    const res = await api.post("/email/contacts/estimate", {
      filters: {
        q,
        source,
        active,
        limit,
        preferred_limit: preferredLimit || null,
        ...(audienceKind ? { audience_kind: audienceKind } : {}),
        ...(includeMyContacts ? { include_my_contacts: true } : {}),
      },
      exclude_recent: excludeRecent,
      days,
      segment,
    });
    return res.data;
  },

  // Select ALL eligible contacts across the full database (bypasses pagination)
  selectAll: async ({ q = "", source = null, active = true, excludeRecent = true, days = 7, segment = "" } = {}) => {
    const res = await api.post("/email/contacts/estimate", {
      filters: { q, source, active, limit: 5000 },
      exclude_recent: excludeRecent,
      days,
      segment,
      select_all: true,
    });
    return res.data;
  },
};
